// extracted by mini-css-extract-plugin
export default {"darkBG":"ModalPDF_darkBG__c0giQ","centered":"ModalPDF_centered__YMZVv","modal":"ModalPDF_modal__bPTpt"};